var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.lazyDom)?_vm._t("default"):_c('div',{staticClass:"text-center blue icon-loading-size"},[_c('i',{staticClass:"el-icon-loading"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }